import { render, staticRenderFns } from "./collectionRank.vue?vue&type=template&id=6838d492&scoped=true&"
import script from "./collectionRank.vue?vue&type=script&lang=js&"
export * from "./collectionRank.vue?vue&type=script&lang=js&"
import style0 from "./collectionRank.vue?vue&type=style&index=0&id=6838d492&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6838d492",
  null
  
)

export default component.exports